/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MemberId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MemberId({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/MemberId"
  
}) {
let assignedInsuranceInsuranceSubscriptionMemberIdValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.member_id',
})
  return (<React.Fragment
>
<div
  data-testid="MemberId.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="assigned_insurance.insurance_subscription.member_id"
 text={assignedInsuranceInsuranceSubscriptionMemberIdValueData}
/>
</div>
{children}
</React.Fragment>)
}